import { Link } from "react-router-dom";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { fmtNum } from "../../lib/format";

// Ücret kartı eksik personel uyarısı: brüt ücretler tutarına girmeyen puantaj günleri, personel kartına bağlantı
export default function UnpricedBanner({ rows, backTo, testid }) {
  const people = new Map();
  (rows || []).forEach((r) => (r.unpriced_people || []).forEach((u) => {
    const cur = people.get(u.id) || { ...u, days: 0, periods: new Set() };
    cur.days += u.days; cur.periods.add(r.period); people.set(u.id, cur);
  }));
  if (!people.size) return null;
  const list = [...people.values()].sort((a, b) => a.name.localeCompare(b.name, "tr"));
  const totalDays = list.reduce((a, u) => a + u.days, 0);
  const link = (id) => `/veri-girisi?bolum=personel&personel=${id}${backTo ? `&back=${encodeURIComponent(backTo)}` : ""}`;
  return (
    <div className="mx-4 mb-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2" data-testid={testid}>
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
        <div className="text-xs text-amber-900">
          <b>{list.length} personelin ücret kartında brüt ücret yok</b> — toplam <b>{fmtNum(totalDays)} puantaj günü</b> Brüt Ücretler Tutarı'na girmedi. Personel kartına girip <b>Maaş / Ücret</b> bilgisini tanımlayın:
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {list.map((u) => (
              <Link key={u.id} to={link(u.id)} data-testid={`${testid}-person-${u.id}`} title={`${[...u.periods].sort().join(", ")} · ${fmtNum(u.days)} gün`}
                className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white border border-amber-300 text-amber-900 font-semibold hover:bg-amber-600 hover:text-white hover:border-amber-600 transition-colors">
                <ExternalLink className="w-3 h-3" /> {u.name} <span className="font-normal opacity-70">· {fmtNum(u.days)} gün</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
